import { ClientMessagesTableOptions } from '@tassat/common-definitions';
import { ClientMessageRecord } from '@tassat/fred-definitions';

import { ClientMessagesAgGrid } from './clientMessagesGrid';

export interface ClientMessagesAgGridProps {
    editClientMessage: (message: ClientMessageRecord) => void;
    tableOptions: ClientMessagesTableOptions;
}

export default ClientMessagesAgGrid;